var _circle, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgAnswerChecked(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 10,
    cy: 10,
    r: 10,
    fill: "#2D65F2"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M14.5 7.0001C14.7976 7.31255 14.8737 7.8197 14.5761 8.13215L9.34892 13.7658C9.05133 14.0783 8.56805 14.0783 8.27047 13.7658L5.22319 10.5663C4.9256 10.2539 4.9256 9.74643 5.22319 9.43398C5.52078 9.12153 6.00405 9.12153 6.30164 9.43398L8.81088 12.0661L13.5 6.99982C13.7976 6.68737 14.2024 6.68765 14.5 7.0001Z",
    fill: "#E4EEFF"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAnswerChecked);
export default __webpack_public_path__ + "static/media/answer_checked.1e1e571ede02222024217d1c572bc969.svg";
export { ForwardRef as ReactComponent };